import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import FilterToggleGroup from 'marketplace-ui-common/filters/components/filterToggleGroup/FilterToggleGroup';
import * as SupportSource from 'ecosystem-marketplace-core/constants/search/SupportSource'; // @ts-expect-error module is untyped

import { getSupportSourceFilterI18nKey } from '../../../../utils/i18n';
const ALL = 'ALL';
const supportOrder = [ALL, SupportSource.HUBSPOT, SupportSource.APP_PARTNER];

function getSupportSourceText(value) {
  const key = value === ALL ? 'appMarketplace.storefront.filters.supportSource.items.all' : getSupportSourceFilterI18nKey(value);
  return unescapedText(key);
}

function getOptions() {
  return supportOrder.map(supportSource => ({
    text: getSupportSourceText(supportSource),
    value: supportSource
  }));
}

function SupportSourceFilter({
  onChange,
  value
}) {
  const options = useMemo(() => getOptions(), []);
  return /*#__PURE__*/_jsx(FilterToggleGroup, {
    ariaLabel: unescapedText('appMarketplace.storefront.filters.supportSource.titleText'),
    name: "support-source",
    onChange: event => onChange(SyntheticEvent(event.target.value === ALL ? null : event.target.value, event)),
    options: options,
    value: value || ALL
  });
}

export default SupportSourceFilter;